import React from "react";
import "./HeroSection.css";
import { useTranslation, Trans } from "react-i18next";

function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="hero-container">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <Trans
              i18nKey="homepage.title"
              components={[<span className="hero-highlight" />]}
            />
          </h1>

          <p>{t("homepage.section1_text")}</p>

          <div className="hero-btns">
            <a
              href="https://play.google.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
              aria-label="Google Play Store"
            >
              <img
                src="/images/googlePlayLogo.png"
                alt="Google Play Store"
                className="store-badge"
              />
            </a>

            <a
              href="https://www.apple.com/app-store/"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
              aria-label="Apple App Store"
            >
              <img
                src="/images/appStoreLogo.png"
                alt="Apple App Store"
                className="store-badge"
              />
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <img
            src="/images/home/hero-family.png"
            alt="Familie nutzt Onenizer"
            className="hero-family-img"
          />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
